module.exports = __webpack_public_path__ + "img/opp-load-xml-dialog.af60f7c9.png";